import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { AppNav } from "@/components/layout/AppNav";
import powtoonLogo from "@/assets/powtoon-logo.png";

export function AppHeader({ children }: { children?: ReactNode }) {
  return (
    <header className="border-b bg-card/50 px-6 h-20 flex items-center justify-between">
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <img
            src={powtoonLogo}
            alt="Powtoon – The Unified AI Video Platform"
            className="h-16 w-auto max-h-full object-contain"
          />
        </Link>
      </div>
      <div className="flex items-center gap-6">
        <AppNav />
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </header>
  );
}
